import { render, staticRenderFns } from "./ProductFacets.vue?vue&type=template&id=6fa35377&scoped=true"
import script from "./ProductFacets.vue?vue&type=script&lang=js"
export * from "./ProductFacets.vue?vue&type=script&lang=js"
import style0 from "./ProductFacets.vue?vue&type=style&index=0&id=6fa35377&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa35377",
  null
  
)

export default component.exports